
export default {

    data() {
        return {
            revs: {},
            paginate: {},
            here_btn: false,
            paginate_btn: false,
            show_head: false
        };
    },
    props: {
        page_state: {},
        send_review: {},
        item_id: String,
        page_name: ""
    },
    created() {
        this.prepare();
    },
    methods: {
        prepare() {
            if (
                this.send_review.category == "none" ||
                this.send_review.category == " "
            ) {
                return false;
            }

            const data = {
                category: this.send_review.category,
                ids: this.send_review.ids,
                paginate: this.send_review.paginate,
                fake: this.page_state.fake
            };

            const url = this.page_state.hppts_url + "/api/review";

            this.callAxios(data, url);
        },

        callAxios(data, url) {
            const response = axios
                .post(url, data)
                .then(response => {
                    if (response.status == 200) {

                        if (this.page_name == "post" && response.data.revs.total > 0) {
                            this.show_head = true;
                        }
                        if (this.page_state.page_name == "doyoulikeit" && response.data.revs.length > 0) {
                            this.show_head = true;
                        }
                        if (this.send_review.paginate == "paginate") {
                            this.revs = response.data.revs.data;
                            this.paginate = response.data.revs;
                            if (response.data.revs.total > 10) {
                                this.paginate_btn = true;
                            } else {
                                this.paginate_btn = false;
                            }
                        } else {
                            this.revs = response.data.revs;
                            if (response.data.here_btn === true) {
                                this.here_btn = true;
                            }
                        }
                    }
                })
                .catch(thrown => { });
        },
        clickPagenate(n, e) {
            e.preventDefault();

            let url = "";
            if (n == "next") {
                if (this.paginate.next_page_url == null) {
                    return false;
                }
                url = this.paginate.next_page_url;
            } else if (n == "prev") {
                if (this.paginate.prev_page_url == null) {
                    return false;
                }
                url = this.paginate.prev_page_url;
            } else {
                url = this.paginateUrlMaker(n);
            }
            if (url == "") {
                return false;
            }

            this.callAxiosPagenate(url);
            this.paginate_btn = false;

            $(function () {
                var n = window.location.href.slice(
                    window.location.href.indexOf("?") + 4
                );
                var p = $("#jump_paginate").offset().top;
                $("html,body").animate({ scrollTop: p }, "slow");
                return false;
            });
        },
        callAxiosPagenate(url) {
            const response = axios
                .get(url)
                .then(response => {
                    if (response.status == 200) {
                        this.revs = response.data.revs.data;
                        this.paginate = response.data.revs;
                        if (response.data.revs.total > 10) {
                            this.paginate_btn = true;
                        } else {
                            this.paginate_btn = false;
                        }
                    } else {
                        alert("No Data");
                    }
                })
                .catch(thrown => {
                    alert("Error");
                });
        },
        paginateUrlMaker(n) {
            let val = this.paginate.first_page_url.slice(0, -1);
            val = val + n;
            return val;
        }
    }
};
